export class OutdatedPassword extends Error {}
